


export class McIcon extends HTMLElement {

  /** @type {SVGElement} **/
  svg;

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
  }

  static get observedAttributes() {
    return ["width", "stroke", "height"]
  }


  attributeChangedCallback(name, _, nv) {
    switch (name) {
      case "width":
        this.svg.setAttribute("width", nv)
      case "height":
        this.svg.setAttribute("height", nv)
      case "stroke":
        this.svg.setAttribute("stroke", nv)
    }
  }

  /**@param {HTMLTemplateElement} temp **/
  addHTML(temp) {
    this.shadowRoot.append(temp.content.cloneNode(true))
    this.svg = this.shadowRoot.querySelector("svg")
  }
}


if (!window.customElements.get("mc-icon")) {
  window.customElements.define("mc-icon", McIcon)
}


